import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Menu, MenuItem, Button, Box, Typography } from "@mui/material";
import { ArrowDown2, ArrowUp2 } from "iconsax-react";
const flags = [
    { code: "nl", label: "NL", icon: "/assets/images/nl-flag.svg" },
    { code: "en", label: "INT", icon: "/assets/images/glob.png" },
];
export const FlagDropdown = ({ onChange, defaultValue, disabled = false }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [selectedCode, setSelectedCode] = React.useState(() => defaultValue === 'INT' ? 'en' : 'nl');
    const open = Boolean(anchorEl);
    React.useEffect(() => {
        setSelectedCode(defaultValue === 'INT' ? 'en' : 'nl');
    }, [defaultValue]);
    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleSelect = (code) => {
        setSelectedCode(code);
        onChange?.(code === 'nl');
        setAnchorEl(null);
    };
    const current = flags.find((f) => f.code === selectedCode) || flags[0];
    return (_jsxs(_Fragment, { children: [_jsx(Button, { disabled: disabled, variant: "outlined", onClick: handleOpen, size: "small", sx: {
                    height: "53.13px",
                    width: "100%",
                    border: `1px solid ${open ? "#0F92FD" : "#00244D33"}`,
                }, children: _jsxs(Box, { display: "flex", alignItems: "center", gap: "4px", children: [_jsx("img", { src: current.icon, alt: current.code, style: {
                                width: 18,
                                height: 18,
                                borderRadius: "2px",
                            } }), _jsx(Typography, { variant: "body2", color: "#00244D", children: current.label }), open ? (_jsx(ArrowUp2, { size: "10px", color: "#00244D99" })) : (_jsx(ArrowDown2, { size: "10px", color: "#00244D99" }))] }) }), _jsx(Menu, { anchorEl: anchorEl, open: open, onClose: () => setAnchorEl(null), anchorOrigin: { vertical: "bottom", horizontal: "right" }, transformOrigin: { vertical: "top", horizontal: "right" }, children: flags.map((flag) => (_jsx(MenuItem, { disabled: disabled, onClick: () => handleSelect(flag.code), selected: flag.code === selectedCode, children: _jsxs(Box, { display: "flex", alignItems: "center", children: [_jsx("img", { src: flag.icon, alt: flag.code, style: {
                                    width: 20,
                                    height: 20,
                                    marginRight: "8px",
                                } }), _jsx(Typography, { variant: "body2", children: flag.label })] }) }, flag.code))) })] }));
};
